import { chartColors } from './chartColors';

export const getColumnOptions = ({ series, labels }) => ({
  chart: {
    height: 350,
    type: 'bar',
    stacked: true,
    toolbar: {
      show: false,
    },
  },
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: '50%',
    },
  },
  series,
  xaxis: {
    categories: labels,
  },
  yaxis: {
    labels: {
      offsetX: -10,
    },
  },
  colors: chartColors,
  fill: {
    opacity: 1,
  },
  legend: {
    offsetY: 7,
  },
  tooltip: {
    y: {},
  },
  grid: {
    row: {
      colors: ['transparent', 'transparent'],
      opacity: 0.2,
    },
    borderColor: 'black',
    padding: {
      top: -20,
      right: 0,
      bottom: -5,
      left: 0,
    },
  },
});
